export default function formatIFSCScoreTuple(tuple: number[]) {
  return `${tuple[0]}T ${tuple[1]}Z ${-tuple[2]}TA ${-tuple[3]}ZA`;
}
